import { connect } from 'react-redux'
import { compose, withHandlers, withState } from 'recompose'

import handlers from './handlers'
import mapDispatchToProps from './mapDispatchToProps'
import mapStateToProps from './mapStateToProps'
import renderer from './cognitoLoginRenderer'

const LoginComponent = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('showForgotPassword', 'setShowForgotPassword', false),
  withState('showErrorMessage', 'setShowErrorMessage', false),
  withState('username', 'setUsername', DEFAULT_USERNAME),
  withState('password', 'setPassword', DEFAULT_PASSWORD),
  withState('errorText', 'setError', ''),
  withState('anchorEl', 'setAnchorEl', null),
  withHandlers(handlers)
)(renderer)

export default LoginComponent
